// Add class to body-element on tab click

const LenderDetail = () => {
  const self = {
    init () {
      const $component = document.querySelector('.LenderDetail')
      if (!$component) return
      self.addEventListeners()
    },
    onClick (e) {
      e.preventDefault()
      const href = document
        .querySelector('.LenderDetail__cta-link')
        .getAttribute('href')
      window.open(href, '_blank')
    },
    addEventListeners () {
      const $lenderDetailPrimary = document.querySelector(
        '.LenderDetail__primary'
      )
      $lenderDetailPrimary.addEventListener('click', self.onClick)
    }
  }

  return self
}

export default LenderDetail
